import { lazy } from "react";

const Dashboard = lazy(() => import("../Component/Dashboard/Dashboard"));
const AddNews = lazy(() => import("../Component/ManageNews.jsx/AddNews"));
const NewsDetails = lazy(() => import("../Component/Dashboard/NewsDetails"));
const MyRatings = lazy(() => import("../Component/MyRatings/MyRatings"));

const dashboardRoutes = [
  { path: "/dashboard", element: <Dashboard />, protected: true },
  { path: "/update-news", element: <AddNews />, protected: true },
  { path: "/news-details/:id", element: <NewsDetails />, protected: true },
  { path: "/my-ratings", element: <MyRatings />, protected: true },
];

export default dashboardRoutes;
